<div class="text">
  <div class="text__label">
    <ion-label>{{question.label}}</ion-label>
  </div>
  <div class="text-input-group"
       style="display:block">
    <div class="form-group">
      <input type="text"
             class="form-control type_msg"
             required
             #input
             #text="ngModel"
             [class.has-error]="question.error"
             [placeholder]="question.label"
             [maskito]="mask"
             [name]="question.key"
             [(ngModel)]="question.editingValue"
             (blur)="save()"
             (cdkAutofill)="save()"
             (keyup.enter)="save()"
             (ngModelChange)="question.error = null"/>
    </div>
  </div>
</div>
